export default function Mission() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#4DB8D4]/10 border border-[#4DB8D4]/20 px-4 py-2 rounded-full mb-6">
            <i className="ri-compass-3-line text-[#4DB8D4] text-sm"></i>
            <span className="text-xs font-semibold tracking-widest uppercase text-[#0F1F3D]">
              Our Mission
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-serif text-[#0F1F3D] leading-tight max-w-3xl mx-auto mb-8">
            Helping Veterinarians Expand Their Impact
          </h2>
          <p className="text-lg lg:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
            Our mission is to help veterinarians expand their impact through modern services that improve access to care.
          </p>
        </div>

        {/* Mission Content */}
        <div className="bg-[#F8FCFD] border border-[#4DB8D4]/20 rounded-2xl p-10 lg:p-12">
          <p className="text-base lg:text-lg text-gray-700 leading-relaxed mb-6">
            We believe trusted veterinary support can be more accessible, more convenient, and in many cases more affordable than relying only on traditional brick-and-mortar care.
          </p>
          
          <div className="border-t border-[#4DB8D4]/20 pt-8 mt-8">
            <h3 className="text-2xl font-semibold text-[#0F1F3D] mb-4">
              Why Vetuvia Exists
            </h3>
            <p className="text-base lg:text-lg text-gray-700 leading-relaxed mb-4">
              The traditional veterinary model does not always make it easy for pet owners to get timely, trusted support. At the same time, many veterinarians want more flexibility, more ownership, and more ways to serve beyond the clinic.
            </p>
            <p className="text-base lg:text-lg text-gray-700 leading-relaxed mb-4">
              <strong className="text-[#0F1F3D]">Vetuvia was created to bridge that gap.</strong>
            </p>
            <p className="text-base lg:text-lg text-gray-700 leading-relaxed">
              We are building a platform that helps veterinarians create new ways to serve through teleconsults, memberships, curated products, and digital services — while keeping the veterinarian-client relationship at the center.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
